<app-user-statistics-files kind="pure-originals"></app-user-statistics-files>

